var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileInAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B7ACBB6D-3054-4925-902A-DC66B5099AB4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 0.662745 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0_Campaign_06.5.5",
    transform: "translate(-903.000000, -450.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(328.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-of-Measurements-Copy",
    transform: "translate(50.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "app-store",
    transform: "translate(510.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9465517,0 L4.88793103,0 C2.19272586,0 0,2.19272586 0,4.88793103 L0,18.9465517 C0,21.6417569 2.19272586,23.8344828 4.88793103,23.8344828 L18.9465517,23.8344828 C21.6417569,23.8344828 23.8344828,21.6417569 23.8344828,18.9465517 L23.8344828,4.88793103 C23.8344828,2.19272586 21.6417569,0 18.9465517,0 Z M22.437931,18.9465517 C22.437931,20.8716983 20.8716983,22.437931 18.9465517,22.437931 L4.88793103,22.437931 C2.96278448,22.437931 1.39655172,20.8716983 1.39655172,18.9465517 L1.39655172,4.88793103 C1.39655172,2.96278448 2.96278448,1.39655172 4.88793103,1.39655172 L18.9465517,1.39655172 C20.8716983,1.39655172 22.437931,2.96278448 22.437931,4.88793103 L22.437931,18.9465517 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2283483,5.75058103 C14.1478603,5.45032241 13.9553224,5.19931552 13.6861138,5.04392586 C13.1304724,4.72309138 12.4173,4.9140931 12.0963724,5.46992069 L11.9172414,5.78014138 L11.7381103,5.46987414 C11.4172293,4.91418621 10.7041034,4.72309138 10.148369,5.04387931 L10.1483224,5.04387931 C9.59258793,5.36476034 9.40153966,6.07788621 9.72237414,6.63366724 L10.5733862,8.10768103 L7.43328621,13.5465517 L5.14396552,13.5465517 C4.50225,13.5465517 3.98017241,14.0686293 3.98017241,14.7103448 C3.98017241,15.3520603 4.50225,15.8741379 5.14396552,15.8741379 L13.9822759,15.8741379 L12.6384207,13.5465517 L10.12095,13.5465517 L14.1120621,6.63371379 C14.2674983,6.36450517 14.3088362,6.05083966 14.2283483,5.75058103 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6905172,13.5465517 L16.4011966,13.5465517 L13.7986293,9.03876207 L12.4548207,11.3663483 L16.4956966,18.3653069 C16.6511328,18.6345621 16.9020466,18.8271466 17.2023983,18.9076345 C17.3026707,18.9344948 17.4043862,18.9478086 17.5054966,18.9478086 C17.7071586,18.9478086 17.9062138,18.8949259 18.0855776,18.7913483 C18.6413121,18.4704672 18.8323603,17.7572948 18.5114793,17.2016069 L17.7450052,15.8741379 L18.6905172,15.8741379 C19.3322328,15.8741379 19.8543103,15.3520603 19.8543103,14.7103448 C19.8543103,14.0686293 19.3322328,13.5465517 18.6905172,13.5465517 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55194483,16.8051724 L5.32305,17.2016069 C5.00221552,17.7573414 5.19331034,18.4705138 5.74904483,18.7913483 C5.93185345,18.896881 6.13165345,18.9470638 6.32898621,18.9470173 C6.73147241,18.9470173 7.12348448,18.7382793 7.33883276,18.3653534 L8.23960862,16.8051724 L5.55194483,16.8051724 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileInAppIcon);
export default __webpack_public_path__ + "static/media/MobileInAppIcon.a9dc9e511a217c539f9c9c875282b488.svg";
export { ForwardRef as ReactComponent };